export default __webpack_public_path__ + "static/german-3-9adbe53b75249df2815ec6d12e5ec314.png";